import React from 'react';
import { useSocket } from '../context/SocketProvider';

const ConnectionStatus = () => {
    const { mainSocketConnected, audioSocketConnected, connectionError } = useSocket();

    if (!mainSocketConnected || !audioSocketConnected) {
        return (
            <div className="connection-status">
                <div className="connection-message">
                    {connectionError && <p className="error-message">{connectionError}</p>}
                    {!mainSocketConnected && <p>Connecting to chat server...</p>}
                    {!audioSocketConnected && <p>Connecting to audio server...</p>}
                </div>
            </div>
        );
    }

    return null;
};

export default ConnectionStatus; 